<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品编辑</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card" style="margin-top:20px">
      <el-form
        :inline="false"
        :model="ruleForm"
        :rules="rules"
        ref="formForRef"
        label-width="80px"
        autocomplete="on"
        size="mini"
      >
        <el-tabs v-model="activeName" @tab-click="tabClick">

          <el-tab-pane label="基本信息" name="first">
            <el-row :gutter="24">
              <el-col :span="7">
                <el-form-item label="产品名称" prop="goods_name">
                  <el-input placeholder="请输入产品名称"  v-model="ruleForm.goods_name" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="日期">
                  <el-date-picker clearable type="date" placeholder="选择日期" v-model="ruleForm.upload_time" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="分类" prop="cat_id">
                  <el-cascader v-model="ruleForm.cat_id"  style="width: 100%" ref="cascaderAddr" @change="getval($event)" :props="{ value: 'id',label: 'name',children: 'children',checkStrictly: true}" :options="cateMenus" clearable></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="7">
                <el-form-item label="销售价格" >
                  <el-input v-model="ruleForm.shop_price"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="市场价格" >
                  <el-input v-model="ruleForm.market_price"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="批发价格" >
                  <el-input v-model="ruleForm.cost_price"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="7">
                <el-form-item required label="孔距" >
                  <el-select v-model="ruleForm.pitch_id" style="width: 200px;" placeholder="请选择车系"  @change="handleIsopenSelect">
                  <el-option :key="item.id"  v-for="item in pitchMenus" :label="item.pid>0?'|--'+item.name:item.name" :value="item.id"></el-option>
                </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="17">
                <el-form-item label="">
                  <el-checkbox v-model="ruleForm.is_hot" label="热销产品" ></el-checkbox>
                  <el-checkbox v-model="ruleForm.is_new" label="新品" ></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
<!--            <el-row :gutter="24" :key="index" v-for="(item,index) in serviceTagTree">-->
<!--              <el-col :span="24">-->
<!--                <el-form-item   :label="item.name">-->
<!--                  <el-radio-group v-model="tags[index]">-->
<!--                    <el-radio v-for="im in item.children"  :key="im.id"  :label="im.id" >{{im.name}}</el-radio>-->
<!--                  </el-radio-group>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--            <el-row :gutter="24">-->
<!--              <el-col :span="24">-->
<!--                <el-form-item label="封面图">-->
<!--                    <el-button type="info" size="mini"  @click="chooseDoc"><i class="el-icon-download"></i>产品选择</el-button>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="产品简介">
                  <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入简介"
                    v-model="ruleForm.goods_brief">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="封面图片">
                 <i class="el-icon-camera" style="font-size:80px;" v-show="!ruleForm.goods_img" @click="showImgDoc(1,'')"></i>
                 <el-image class="main_image"
                            v-show="ruleForm.goods_img" :src="ruleForm.goods_img" @click="showImgDoc(1,'')"></el-image>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="效果图片">
                  <i class="el-icon-camera" style="font-size:80px;" v-show="!ruleForm.file_url" @click="showImgDoc(3,'')"></i>
                  <el-image class="main_image"
                            v-show="ruleForm.file_url" :src="ruleForm.file_url" @click="showImgDoc(3,'')"></el-image>
                </el-form-item>
              </el-col>
            </el-row>
<!--            <el-row>-->
<!--              <el-col>-->
<!--                <el-form-item label="展示图片">-->
<!--                  <el-upload-->
<!--                    class="upload-demo"-->
<!--                    drag-->
<!--                    action="#"-->
<!--                    :before-upload="handleBeforeUpload"-->
<!--                    :on-remove="handleRemove"-->
<!--                    :on-success="uploadSuccess"-->
<!--                    :auto-upload="false"-->
<!--                    :on-change="uploadFile"-->
<!--                    :file-list="fileList"-->
<!--                    list-type="picture"-->
<!--                    multiple-->
<!--                  >-->
<!--                    <i class="el-icon-upload"></i>-->
<!--                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>-->
<!--                    <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>-->
<!--                  </el-upload>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
            <el-row>
              <el-col>
                <el-form-item label="图片URL">
                  <el-input v-model="ruleForm.file_url"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </el-tab-pane>
          <el-tab-pane label="产品规格" name="second">
            <el-row :gutter="20" >
              <el-col :span="24" >
                <el-form-item label="产品属性">
                  <el-select v-model="ruleForm.goods_type"  placeholder="--请选择--"  @change="chooseType($event)">
                    <el-option
                      v-for="item in typeMenus"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <!--属性--->
                <el-form-item v-for="(item ,idx) in attrList"  :key="idx" :label="item.attr_name" >
                  <el-input   v-model="item.attr_values"   v-if="item.attr_input_type == 0"  :placeholder="'请输入'+item.attr_name" ></el-input>
                  <el-select  @change="((val)=>{chooseAttr(val,idx)})"
                              @remove-tag="((val)=>{removeTag(val,idx)})"
                              style="width:100%" v-if="item.attr_input_type == 1 && item.val.length>0" multiple
                              v-model="item.val[index].ck_id"  placeholder="--请选择--">
                    <el-option
                      v-for="(itm)  in item.val"

                      :value="itm.name" :key="itm.id" >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-show="tableData.length>0" >
              <el-col :span="24">
                <!--sku板块-->
                <el-table :key="key"  :data="tableData">
                  <el-table-column label="序号"  align="center" width="50">
                    <template slot-scope="scope">
                      {{scope.$index+1}}
                    </template>
                  </el-table-column>
                  <el-table-column  v-for="(item,idx) in tableHeader" :key="idx"  align="center"  class-name="cellDefault">
                    <template  slot="header" >
                      <el-tooltip  effect="light" placement="bottom" trigger ="hover">
                        <div slot="content" style="max-width:200px;">{{item.name}}</div>
                        <el-input  style="background:#ddd" :disabled="true" class="headerBox" v-model="item.name" />
                      </el-tooltip>
                    </template>

                    <template slot-scope="scope" >
                      <div slot="content" style="max-width:200px;"></div>
                      <el-input :disabled="true" v-model="scope.row[idx].name"  @input="setInputVal" class="name-input"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column  label="图片"  align="center" width="100">
                    <template slot-scope="scope">
                      <i class="el-icon-camera" style="font-size:40px;" v-show="!tableData[scope.$index].file_url" @click="showImgDoc(2,scope.$index)"></i>
                      <el-image style="width: 40px; height: 40px" v-show="tableData[scope.$index].file_url" :src="tableData[scope.$index].file_url" @click="showImgDoc(2,scope.$index)"></el-image>
                    </template>
                  </el-table-column>
                  <el-table-column label="销售价"  align="center" width="100">
                    <template slot-scope="scope">
                      <input style="display:block;width: 80px;height:40px;border-radius:5px;  border: 1px solid #d5d5d5" v-model="tableData[scope.$index].goods_price"   class="name-input"/>
                    </template>
                  </el-table-column>
                  <el-table-column label="市场价"  align="center" width="100">
                    <template slot-scope="scope">
                      <input style="display:block;width: 80px;height:40px;border-radius:5px;  border: 1px solid #d5d5d5" v-model="tableData[scope.$index].market_price"  class="name-input"/>
                    </template>
                  </el-table-column>
                  <el-table-column label="一件代发价格"  align="center" width="100">
                    <template slot-scope="scope">
                      <input style="display:block;width: 80px;height:40px;border-radius:5px;  border: 1px solid #d5d5d5" v-model="tableData[scope.$index].cost_price"  class="name-input"/>
                    </template>
                  </el-table-column>
                  <el-table-column label="库存数"  align="center" width="100">
                    <template slot-scope="scope">
                      <input style="display:block;width: 80px;height:40px;border-radius:5px;  border: 1px solid #d5d5d5" v-model="tableData[scope.$index].goods_stock"  class="name-input"/>
                    </template>
                  </el-table-column>
                  <el-table-column label="SKU编码"  align="center" width="100">
                    <template slot-scope="scope">
                      <input style="display:block;width: 80px;height:40px;border-radius:5px;  border: 1px solid #d5d5d5" v-model="tableData[scope.$index].shop_code"  class="name-input"/>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="详情信息" name="third">
            <el-row>
              <el-col>
                <!-- 卡片 -->
                <div style="border: 1px solid #ccc;z-index: 9999;">
                  <Toolbar
                    style="border-bottom: 1px solid #ccc"
                    :editor="editor"
                    :defaultConfig="toolbarConfig"
                    :mode="mode"
                  />
                  <Editor
                    style="height: 300px; overflow-y: hidden;"
                    v-model="ruleForm.content"
                    :defaultConfig="editorConfig"
                    :mode="mode"
                    @onCreated="onCreated"
                    @onChange="onChange"
                  />
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="视频信息" name="fourth">
            <el-row>
              <el-col>
                <el-form-item label="视频文件" prop="video_url">
                  <el-upload
                    class="upload-demo"
                    action="#"
                    :auto-upload="false"
                    :on-preview="handleFilePreview"
                    :on-remove="handleFileRemove"
                    :before-remove="beforeFileRemove"
                    :on-success="uploadFileSuccess"
                    :on-change="uploadFile1"
                    multiple
                    :limit="1"
                    :on-exceed="handleFileExceed"
                    :file-list="fileList1">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传.mp4文件，且不超过500kb</div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="视频URL">
                  <el-input v-model="ruleForm.video_url"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>

        <el-row style="margin-top: 10px;">
          <el-col>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <eShop  :formData="formData"
            :visible.sync="visible"
            :title="title"
            :closeForm="closeForm"
    />
    <eDocList :formData="formData1"
             :visible.sync="visible1"
             :title="title1"
             :closeForm="closeForm1"
              v-on:eventChoose="eChooseDoc"
    />
  </div>
</template>
<script>
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
  import moment from 'moment'     //日期时间转换
  import axios from 'axios'
  import CryptoJS from "crypto-js";
  import eShop from "../common/eShopList";
  import eDocList from "../common/eDocList";
  export default {
    components: { Editor, Toolbar,eShop,eDocList },
    data() {
      return {
        type_img:1,
        key:0,
        sku_index:'',
        activeName:"first",
        attr:[],
        tags:[],
        index:0,

        formData:{},
        title:'',
        visible:false,

        formData1:{},
        title1:'',
        visible1:false,

        baseUrl:'/api/',
        fileList:[],
        fileList1:[],
        pitchMenus:[],
        ruleForm:{
          pitch_id:'',
          upload_time:'',
          cat_id:'',
          url:'',
          id:'',
          content: '',
          file_url:'',
          video_url:'',
          goods_name:'',
          shop_price:'',
          market_price:'',
          cost_price:'',
          is_hot:0,
          is_new:0,
          goods_brief:'',
          goods_type:'',
          tag_id:'',
          shop_name:'',
          shop_id:'',
          goods_img:'',
        },
        cateMenus:[],
        editor: null,

        toolbarConfig: { },
        editorConfig: { placeholder: '请输入内容...',
          // 所有的菜单配置，都要在 MENU_CONF 属性下
          MENU_CONF: {
            //配置上传图片
            uploadImage: {
              customUpload: this.uploadImg
            }
          }
        },
        mode: 'default', // or 'simple'
        rules: {
          goods_name:[
            { required: true, message: "请输入产品名称", trigger: 'change' }
          ],
          cat_id:[
            { required: true, message: "请选择分类", trigger: 'change' }
          ],

        },
        tmp_data:[],
        typeMenus: [],
        attrList: [],
        skuList: [],
        skuRs: [],
        skuResultList: [],
        loading:true,
        tableHeader: [

        ],
        tableData: [],
        serviceTagTree:[],

        isShowShop:false
      }
    },
    mounted() {
      // 模拟 ajax 请求，异步渲染编辑器
      this.getPitchTree();
      this.getCateMenus();
      this.toolbarConfig.modalAppendToBody = true
      let _this=this;
      _this.uri = _this.urlParse();
      console.log('uri----', _this.uri.searchParams)
      _this.ruleForm.id = _this.uri.searchParams.id;
      if (_this.ruleForm.id > 0) {
        _this.getOne();
      }
      _this.getServiceTagTree();
      _this.getGoodsTypeTable();

    },
    methods: {
      eChooseDoc(id,...params){

        if(this.type_img==2){
          this.tableData[this.sku_index].file_url=params[1];
          this.$nextTick(()=>{
            this.key++;
          })
        }else if(this.type_img==1){
          this.ruleForm.goods_img=params[1];
        }else if(this.type_img==3){
          this.ruleForm.file_url=params[1];
        }

      },
      getPitchTree(){
        let _this=this;
        let param={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id')
        };
        this.$axios.findPitchTable(param).then((res)=>{
          if(res.code==200){
            _this.pitchMenus=res.data;
          }
          console.log(res);
        });

      },
      showImgDoc(type,index){
        this.type_img=type;
        if(type==2){
          this.sku_index=index;
        }
        this.title1="图片选择";
        this.visible1=true;
      },
      chooseDoc(){
        this.title1="选择图片";
        this.visible1=true;
      },
      closeForm1(){

        this.visible1=false;
      },
      handleRemove(file) {
        const index = this.fileList.indexOf(file);
        //let itm=  this.fileList[index];

        // if(this.ruleForm.id&&this.ruleForm.id>0&&itm.foreign_id){
        //   this.$confirm('此操作将删除该文档, 是否继续?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //     const param = {
        //       operator_id: sessionStorage.getItem('user_id'),
        //       company_id:sessionStorage.getItem('company_id'),
        //       access_token:sessionStorage.getItem('token'),
        //       foreign_id: itm.foreign_id,
        //       source: itm.source,
        //       upload_id: itm.upload_id,
        //     }
        //     this.$axios.uploadDel(param).then(res=>{
        //       console.log('-----222222----',res)
        //       if(res.code == 200){
        //         _this.$message.success(res.msg);
        //       }else{
        //         _this.$message.error(res.msg);
        //       }
        //     }).catch(error=>{
        //       console.log(error);
        //     })
        //
        //   }).catch(function(e) {
        //     console.log('e-------')
        //     // 点击取消:不删除了
        //     _this.$message({
        //       type: 'info',
        //       message: '已取消删除'
        //     });
        //   });
        // }
        this.fileList.splice(index, 1)

      },
      setInputVal(){

      },
      chooseAttr(val,idx){
        //console.log('val----',val);
        // console.log('idx-----',idx)
        val.forEach((item)=>{
          //  console.log('this.attrList[idx].val:',  this.attrList[idx].val.find(option => option.name === item));
          let findex = this.attrList[idx].val.findIndex(option => option.name === item);
         // const selectedKey = this.attrList[idx].val.find(option => option.name === item).id;
          this.attrList[idx].val[findex].is_checked=1;
          // console.log('Selected key:', selectedKey);
        })



        // console.log('add----',this.attrList)

        if( this.tableHeader.length>0){
          let fix = this.tableHeader.findIndex(option => option.name === this.attrList[idx].attr_name);
          if(fix==-1){
            this.tableHeader.push({attr_id:this.attrList[idx].attr_id, name:this.attrList[idx].attr_name,nameEn:this.attrList[idx].name_en,index:idx});
          }

        }else{
          this.tableHeader.push({attr_id:this.attrList[idx].attr_id,name:this.attrList[idx].attr_name,nameEn:this.attrList[idx].name_en,index:idx});
          //   this.attrList[idx].val.forEach(el=>{
          //      if(el.is_checked==1){
          //          _this.tmp_data[idx]=[];
          //        _this.tmp_data[idx].push({name: el.name});
          //      }
          //   })
          //
        }
        console.log('this.tableHeader-----',this.tableHeader)


        this.cacu();
        // console.log('tmp_data-----',_this.tmp_data)
        //let rs=this.cartesianProductOf(_this.tmp_data);
        // console.log('rs-----',rs)
        //this.tableData.push(rs);
      },
      removeTag(val,idx){
        console.log('del idx------',idx)
        console.log('del val------',val)

        let findex = this.attrList[idx].val.findIndex(option => option.name === val);
        this.attrList[idx].val[findex].is_checked=0;
        console.log('del 1----',this.attrList)
        this.cacu();
      },
      cacu(){
        this.tableData=[];
        this.tmp_data=[];
        let _this=this;
        if(this.tableHeader.length>0){
          console.log('this.attrList---',this.attrList)
          this.tableHeader.forEach((item,idx)=>{
            // console.log('9999----',idx)
            // console.log('item---',item)
            // console.log('index---',index)
            if(_this.tmp_data[idx]==undefined){
              _this.tmp_data[idx]=[];
            }
            //console.log('_this.tmp_data[idx]----',_this.tmp_data[idx])
            // console.log('0000---',_this.tmp_data[idx].length)

            this.attrList[item.index].val.forEach(el=>{
              if(el.is_checked==1){
                let fix =  _this.tmp_data[idx].findIndex(option => option.name === el.name);
                //  console.log('fix---',fix)
                if(fix==-1) {
                  _this.tmp_data[idx].push({attr_id:el.attr_id,id:el.id,name: el.name,nameEn:el.name_en});
                }
              }
            })
            if(_this.tmp_data[idx].length==0){
              _this.tableHeader.splice(idx,1);
              _this.tmp_data.splice(idx,1);
            }
          })
          console.log(' _this.tmp_data', _this.tmp_data)

          let rs=this.cartesianProductOf(_this.tmp_data);


          console.log('rs-----',rs)
          this.tableData=rs;
          if(this.tableData&&this.tableData.length>0){
            this.tableData.forEach((el,idx)=>{
              this.tableData[idx].goods_stock=0;
              this.tableData[idx].shop_code="";
              this.tableData[idx].goods_price="";
              this.tableData[idx].cost_price="";
              this.tableData[idx].market_price="";
              this.tableData[idx].file_url="";
            })
          }

        }
      },

      /**
       * 生成笛卡尔积数据
       * cartesianProductOf([arr1, arr2, arr3 ...])
       */
      cartesianProductOf(arrays){
        if (!arrays.length) {
          return []
        }
        return Array.prototype.reduce.call(arrays, (arr1, arr2) => {
          var ret = []
          arr1.forEach(v1 => {
            arr2.forEach(v2 => {
              ret.push(v1.concat([v2]))
            })
          })
          return ret
        }, [[]])
      },
      tabClick(e){
        console.log(e)
      },
      chooseType(e){
        console.log('chooseType',e)
        this.getAttributeList(e);
      },
      closeForm(){
        this.title="";
        this.visible=false;
      },
      getAttributeList(type_id){
        let _this=this;
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          type_id:type_id
        }
        this.$axios.goodsAttributesList(param).then(res=>{
          if(res.code == 200){
            _this.attrList = res.data;
            // _this.getAttrList();
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getGoodsTypeTable(){
        let _this=this;
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          shop_id:sessionStorage.getItem('shop_id'),
        }
        this.$axios.goodsTypeTable(param).then(res=>{
          if(res.code == 200){
            _this.typeMenus = res.data;
            // _this.getAttrList();
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      chooseShop(id,...params){
        this.ruleForm.shop_id=id;
        this.ruleForm.shop_name=params[0];
      },
      chooseM(){
        this.isShowShop=true;
      },
      handleFilePreview(){

      },

      beforeFileRemove(){

      },
      handleFileExceed(){

      },
      getServiceTagTree(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          group_id: 1,
        }
        this.$axios.serviceTagTree(param).then(res=>{
          if(res.code == 200){
            this.serviceTagTree = res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      uploadFileSuccess(res){
        console.log('doc--------',res)
        let _this=this;
        if(res.code==0){
          _this.ruleForm.video_url= res.data.src;
        }
      },
      submitForm(){
        let _this=this;
        this.$refs.formForRef.validate((valid) => {
          if (valid) {
            let params={
              goods_id: _this.ruleForm.id,
              access_token:sessionStorage.getItem('token'),
              company_id:sessionStorage.getItem('company_id'),
              shop_id:sessionStorage.getItem('shop_id'),
              goods_name:_this.ruleForm.goods_name,
              cat_id:_this.ruleForm.cat_id,
              goods_img: _this.ruleForm.goods_img,
              file_url: _this.ruleForm.file_url,
              goods_gallery:_this.fileList,
              video_url: _this.ruleForm.video_url,
              link: _this.ruleForm.url,
              goods_desc: _this.ruleForm.content,
              summary: _this.ruleForm.summary,
              ishot:_this.ruleForm.ishot?1:0,
              recommond:_this.ruleForm.recommond?1:0,
              istop:_this.ruleForm.istop?1:0,
              upload_time:_this.ruleForm.upload_time,
              market_price: _this.ruleForm.market_price,
              shop_price: _this.ruleForm.shop_price,
              pitch_id: _this.ruleForm.pitch_id,
            };
            if(_this.ruleForm.cost_price){
              params.cost_price=_this.ruleForm.cost_price;
            }
            if(_this.tags.length>0){
              params.tags=_this.tags.join(',');
            }
            console.log('params tags------',_this.tags)
            console.log('params goods------',params)
            console.log('tableHeader----数据-----',this.tableHeader);
            console.log('tabledata----sku数据-----',this.tableData);
            console.log('attrList属性数据-----',this.attrList);
            let goods_attr_list=[];
            let goods_sku_list=[];
            if(this.tableData.length>0){
              this.tableData.forEach((el)=>{
                let sku={}
                let china=[];
                let val=[];

                _this.tableHeader.forEach((item,n)=>{
                  let tmp={attr_id:el[n].attr_id,attr_name:item.name,attr_value:el[n].name,attr_value_id:el[n].id};
                  goods_attr_list.push(tmp)
                  china.push(el[n].name)
                  val.push(el[n].attr_id+":"+el[n].id);
                })
                sku.sku_value=val.join(',')
                sku.sku_china=china.join(',');
                sku.goods_price=el.goods_price;
                sku.cost_price=el.cost_price;
                sku.market_price=el.market_price;
                sku.goods_stock=el.goods_stock;
                sku.shop_code=el.shop_code;
                sku.file_url=el.file_url;
                if(el.sku_id!=undefined&&el.sku_id!=null){
                  sku.sku_id=el.sku_id;
                }
                goods_sku_list.push(sku)
              })
            }
            if(goods_attr_list.length>0&&goods_attr_list.length>0){
              params.goods_attr_list=goods_attr_list;
              params.goods_sku_list=goods_sku_list;
              params.attr_list=this.tableHeader;//this.uniqueJsonArray(goods_attr_list);
            }
            console.log('goods_attr_list--',goods_attr_list)
            console.log('goods_sku_list--',goods_sku_list)
            console.log('goods_attr_list -----',this.tableHeader);

            _this.$axios.goodsSave(params).then((res)=>{
              if(res.code==200){
                this.$message({
                  message:'添加成功！',
                  type:'success',
                  offset:225,
                  duration:4000,
                  onClose:()=>{
                    this.$router.push('/simpleGoodsList')
                  }
                });
              }
              console.log(res);
            });

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },

      uniqueJsonArray(arr) {
        //json 数组去重
        const unique = [];
        const seen = new Set();

        arr.forEach(item => {
          const itemStr = JSON.stringify(item);
          if (!seen.has(itemStr)) {
            seen.add(itemStr);
            unique.push(item);
          }
        });

        return unique;
      },
      getOne(){
        let _this=this;
        let url= _this.baseUrl+'api/cmp.mall.Goods_read_lz/findOne';
        axios.post(url,{
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
          goods_id:_this.ruleForm.id
        }).then((res)=>{
          if(res.data.code==200){
            let item=res.data.data;
            _this.ruleForm.goods_name=res.data.data.goods_name;

            _this.ruleForm.id=res.data.data.goods_id;
            _this.ruleForm.cat_id= res.data.data.cat_id;
            _this.ruleForm.pitch_id= res.data.data.pitch_id;
            _this.ruleForm.content= res.data.data.goods_desc;
            _this.ruleForm.video_url= res.data.data.video_url;
            //_this.editor.txt.html(res.data.data.content);
            _this.ruleForm.goods_img=item.goods_img;
            _this.ruleForm.file_url=item.file_url;
            _this.ruleForm.shop_price=item.shop_price;
            _this.ruleForm.market_price=item.market_price;
            _this.ruleForm.cost_price=item.cost_price;
            //   _this.ruleForm.summary=res.data.data.summary;
            //   _this.ruleForm.recommond=res.data.data.recommond==1?true:false;
            //   _this.ruleForm.istop=res.data.data.istop==1?true:false;
            //   _this.ruleForm.ishot=res.data.data.ishot==1?true:false;
            if(item.upload_time!=null&&item.upload_time>0){
              _this.ruleForm.upload_time=_this.dateFormat(item.upload_time*1000);
            }
            _this.ruleForm.url=res.data.data.link;
            if(item.pictures!=null&&item.pictures){
              item.pictures.forEach(function(el){
                var img={
                  name:el.img_desc?el.img_desc:'',
                  url:el.img_url,

                  // foreign_id:foreign_id,
                  // source:source,
                  // upload_id:el.id
                }
                _this.fileList.push(img);
              })
            }

            if(item.sku!=null&&item.sku){

              item.attr.forEach(function (el,m) {
                let tmp={
                  attr_id:el.attr_id,
                  goods_id:el.goods_id,
                  name:el.attr_name,
                  index:m
                }
                _this.tableHeader.push(tmp);
              })
              item.sku.forEach(function (el) {
                let valueList=el.sku_value.split(',');
                let nameList=el.sku_china.split(',');
                let tmp={};

                _this.tableHeader.forEach(function (it,y) {
                  valueList.forEach(function (vitem,vi) {
                    let a=vitem.split(":");
                    if(it.attr_id==a[0]){
                      tmp[y]={attr_id:a[0],attr_name:it.name,attr_value_id:a[1],id:a[1],name:nameList[vi]};
                    }
                  });
                });
                tmp.sku_id=el.sku_id;
                tmp.goods_id=el.goods_id;
                tmp.sku_value=el.sku_value;
                tmp.goods_price=el.goods_price;
                tmp.cost_price=el.cost_price;
                tmp.market_price=el.market_price;
                tmp.goods_stock=el.goods_stock;
                tmp.shop_code=el.shop_code;
                tmp.goods_code=el.goods_code;
                tmp.file_url=el.file_url;
                console.log('tableData--1111-99---',tmp)
                _this.tableData.push(tmp);
              })
            }
          }

          console.log(res);
        });
      },
      dateFormat:function(time,arg='YYYY-MM-DD'){
        return moment(time).format(arg);
      },
      timeFormat:function(time,arg='YYYY-MM-DD HH:mm:ss'){
        return moment(time).format(arg);
      },
      handleFileRemove(file, fileList) {
        this.fileList=fileList;
      },
      async uploadFile (item) {
        let _this=this;
       // let formData = new FormData()
        let file = item.raw;
        this.logoFile=item.raw;

        let file_md5, file_sha1;
        await this.calculateMD5(file).then(md5 => {
          file_md5 = md5;
          console.log('MD5:', md5)
        });
        await this.calculateSHA1(file).then(sha1 => {
          file_sha1 = sha1;
          console.log('SHA1:', sha1);
        });

        // 获取文件名
        const fileName = file.name;
        // 获取文件大小
        const fileSize = file.size;
        // 获取文件后缀
        const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);

        console.log('文件名称：', fileName);
        console.log('文件后缀：', fileExtension);
        console.log('文件大小：', fileSize);
        let param_1 = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          md5: file_md5,
          sha1: file_sha1,
          size: fileSize
        };
        this.$axios.uploadOne(param_1).then(res => {
          if (res.code == 200) {
            //文件已经存在
            _this.ruleForm.file_url = res.data.url;
            var img = {
              name: res.data.name,
              url: res.data.url
            }
            _this.fileList.push(img);

          } else {

            let param = {
              access_token: sessionStorage.getItem('token'),
              company_id: sessionStorage.getItem('company_id')
            };
            this.$axios.getAliJsonCmp(param).then(res => {
              let data = res['data'];
              console.log('aliyun', data);
              let suffix = _this.get_suffix(file.name);
              let autoname = _this.Ymdhis();
              let key = data['dir'];
              let host = data['host'];
              let path = data['path'] != null && data['path'] != undefined ? data['path'] : '';
              let request = new FormData();
              request.append('name', file.name);
              request.append("key", key + path + autoname + suffix);//文件名字，可设置路径
              request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
              request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
              request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
              request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
              request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
              request.append('file', file);//需要上传的文件 file
              console.log('aliyun5555', request);
              axios.post(host, request, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
                //请求成功，触发then中的函数
                console.log('upload -res--------', res)
                var fileurl = res.data.filename; //上传完成后的文件oss地址
                var fullurl = host + '/' + fileurl;
                _this.ruleForm.file_url = fullurl;
                var img = {
                  name: fileName,
                  url: fullurl
                }
                _this.fileList.push(img);
                //更新上传资料
                let upload_params = {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  name: fileName,
                  size: fileSize,
                  ext: fileExtension,
                  md5: file_md5,
                  sha1: file_sha1,
                  path: fileurl,
                  url: fullurl,
                  status: 1,
                };
                console.log('upload---save params', upload_params)
                _this.$axios.uploadSave(upload_params).then(resu => {
                  console.log('upload---save', resu)
                });

              })
                .catch(error =>
                  //请求失败，触发catch中的函数 可省略
                  console.log(error)
                )
            });

          }
        });
      },
      async readFileAsBinaryString(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
          reader.readAsBinaryString(file);
        });
      },
      async  calculateMD5(file) {
        return  this.readFileAsBinaryString(file).then(binaryString => {
          const words = CryptoJS.lib.WordArray.create(binaryString);
          return CryptoJS.MD5(words).toString();
        });
      },
      async calculateSHA1(file) {
        return  this.readFileAsBinaryString(file).then(binaryString => {
          const words = CryptoJS.lib.WordArray.create(binaryString);
          return CryptoJS.SHA1(words).toString();
        });
      },

      uploadFile1(item){
        let _this=this;
        //let formData = new FormData()
       let file = item.raw;
      //  this.logoFile=item.raw;
        // formData.append('file', file);
        let param={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id')
        };
        this.$axios.getAliJson(param).then(res=>{
          let data = res['data'];
          console.log('aliyun',data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let host = data['host'];
          let request = new FormData();
          let path=data['path']!=null&&data['path']!=undefined?data['path']:'';
          request.append('name', file.name);
          request.append("key", key + path + autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('aliyun5555',request);

          axios.post('/alioss',request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;

            _this.ruleForm.video_url=fullurl;
            var img={
              name:_this.ruleForm.title,
              url:_this.ruleForm.fullurl
            }
            _this.fileList1.push(img);
          })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log(error)
            )
        });
      },
      resetForm(formName){
        this.$refs[formName].resetFields();
      },
      handleBeforeUpload(file) {
        // 在这里可以添加更多的校验逻辑
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传的文件大小不能超过 2MB!');
        }
        return isLt2M;
      },
      uploadSuccess(){

      },
      handleIsopenSelect(){

      },

      getCateMenus(){
        let _this = this;

        let url= '/api/api/cmp.mall.Gcategory_read_lz/findTree';
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        axios.post(url,params).then((res)=>{
          if(res.data.code == 200) {
            _this.cateMenus=res.data.data;
          }
        });
        _this.submit=false;
      },
      getval(val) {
        let _this = this;
       // let checkval = [];
        const obj = this.$refs['cascaderAddr'].getCheckedNodes();
        //  console.log('lk------',obj[0].data.name);
        _this.ruleForm.cat_id = obj[0].data.id;
        //   console.log(this.$refs['cascaderAddr'+index][0].getCheckedNodes());
        //  let checkedNodeList = this.$refs['cascaderAddr'+index][0].getCheckedNodes();

        //  checkedNodeList = checkedNodeList.filter(item => !(item.parent && item.parent.checked)); // 核心
        // for(let i=0;i<checkedNodeList.length;i++){
        //     if(checkedNodeList[i].level==1){
        //         checkval.push(checkedNodeList[i].label+'(全选)')
        //     }else{
        //         checkval.push(checkedNodeList[i].parent.label+'(选项'+(i+1)+'：'+checkedNodeList[i].label+')');
        //     }
        // }
        // this.$set(_this.item_list[index],'checkedNodeList',checkval);
        console.log('lu--------', val);
        // this.$set(_this.item_list[index],'checkedNodeListId',val);
      },
      async uploadImg(file, insertFn){
        console.log('1000--------file---------',file)
        let _this=this;
        let file_md5, file_sha1;
        await this.calculateMD5(file).then(md5 => {
          file_md5 = md5;
          console.log('MD5:', md5)
        });
        await this.calculateSHA1(file).then(sha1 => {
          file_sha1 = sha1;
          console.log('SHA1:', sha1);
        });
        // 获取文件名
        const fileName = file.name;
        // 获取文件大小
        const fileSize = file.size;
        // 获取文件后缀
        const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);

        console.log('文件名称：', fileName);
        console.log('文件后缀：', fileExtension);
        console.log('文件大小：', fileSize);
        let param_1 = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          md5: file_md5,
          sha1: file_sha1,
          size: fileSize
        };

        await this.$axios.uploadOne(param_1).then(res => {
          if (res.code == 200) {
            //文件已经存在
            setTimeout(function () {
              insertFn(res.data.url); //插入地址
            }, 2000);

          } else {

            let param = {
              access_token: sessionStorage.getItem('token'),
              company_id: sessionStorage.getItem('company_id'),
            };
            // console.log(file);
            this.$axios.getAliJsonCmp(param).then(res => {
              console.log('ali_json------', res)
              let data = res['data'];
              console.log(data);
              let suffix = _this.get_suffix(file.name);
              let autoname = _this.Ymdhis();
              let key = data['dir'];
              let host = data['host'];

              let path = data['path'] != null && data['path'] != undefined ? data['path'] : '';
              let request = new FormData();
              request.append('name', file.name);
              request.append("key", key + path + autoname + suffix);//文件名字，可设置路径
              request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
              request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
              request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
              request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
              request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
              request.append('file', file);//需要上传的文件 file
              console.log('request=------', request)
              _this.uploadAliOss(host,request).then(url=>{
                var fileurl = url; //上传完成后的文件oss地址
                var fullurl = host + '/' + fileurl;
                insertFn(fullurl);
                //更新上传资料
                let upload_params = {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  name: fileName,
                  size: fileSize,
                  ext: fileExtension,
                  md5: file_md5,
                  sha1: file_sha1,
                  path: fileurl,
                  url: fullurl,
                  status: 1,
                };
                console.log('upload---save params', upload_params)
                _this.$axios.uploadSave(upload_params).then(resu => {
                  console.log('upload---save', resu)
                });
              });

            });
          }
        });
      },
      async uploadAliOss(host,formData){
        return new Promise((resolve, reject) => {
          axios.post(host, formData,{headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
            console.log('ali oss res 上传结果:',res)
            resolve(res.data.filename) // 假设服务器返回的图片 URL 是 response.data.url
          }).catch(error => {
            reject(error)
          })
        })
      },
      onChange(editor){
        console.log(editor)
        // this.ruleForm.content=this.editor.txt.html();
      },
      onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      },
      get_suffix(filename) {
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos != -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },
      Ymdhis(){
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return ''+year+month+day+hour+minute+second+(Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000);
      },
      urlParse(_url = '') {
        let url_obj = new URL(_url || window.location.href);
        let search_path = url_obj.search;
        let handle_path = decodeURIComponent(search_path.substr(1));

        let handle_path_arr = handle_path.split('&');
        let search_params = {};
        for(let item of handle_path_arr) {
          let r = item.split('=');
          search_params[r[0]] = r[1];
        }
        return {
          protpcol: url_obj.protocol,
          search: url_obj.search,
          host: url_obj.host,
          port: url_obj.port,
          pathname: url_obj.pathname,
          searchParams: search_params
        }
      },
    },

    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
    },

  };
</script>
<style>
  /deep/ .input__inner{color:#333}
  .w-e-modal{z-index: 999 !important;left: 300px !important;top: 300px !important;}
  .main_image img {
    width: 100px; /* 设置图片宽度 */
    height: 100px; /* 设置图片高度 */
    display: block;
  }
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
